<template>
    <div>
        <el-drawer
        :visible.sync="showModal" 
        size="50%"
    >   
        <template slot="title">
            <div class="d-flex align-items-start" :style="{ gap: '8px' }">
                <el-tag class="rounded-circle" type="success">
                    <i class="el-icon-notebook-2"></i>
                </el-tag>
                <div>
                    <span>Consulta SPC</span>
                    <span v-if="spcConsulta && spcConsulta.protocolo" class="text-muted">#{{ spcConsulta.protocolo.numero }}</span>
                </div>
            </div>
        </template>

        <CardBase v-if="spcConsulta">
            <!-- Dados do Consumidor (PJ) -->
            <el-descriptions 
                v-if="getConsumer['consumidor-pessoa-juridica']" 
                title="Dados do consumidor (PJ)" 
                :column="4" 
                size="small" 
                :border="true"
            >
                <el-descriptions-item 
                    :span="4" 
                    label="Razão Social"
                >
                    <span v-if="getConsumer['consumidor-pessoa-juridica']['razao-social']">
                        {{ getConsumer['consumidor-pessoa-juridica']['razao-social'] || 'Não informado' }}
                        
                    </span>
                </el-descriptions-item>

                <el-descriptions-item 
                    :span="4" 
                    label="CNPJ"
                >
                    <span v-if="getConsumer['consumidor-pessoa-juridica']['cnpj']['numero']">
                        {{ getConsumer['consumidor-pessoa-juridica']['cnpj']['numero'] || 'Não informado' }}
                    </span>
                </el-descriptions-item>

                <el-descriptions-item 
                    :span="4" 
                    label="Situação CNPJ"
                >
                    {{ getConsumer['consumidor-pessoa-juridica']['situacao-cnpj']
                        ? getConsumer['consumidor-pessoa-juridica']['situacao-cnpj']['descricao-situacao']
                        : 'Não informado' 
                    }}
                </el-descriptions-item>

                <el-descriptions-item 
                    :span="4" 
                    label="Data Fundação"
                >
                    {{
                        getConsumer['consumidor-pessoa-juridica']['data-fundacao']
                        ? formatDate(getConsumer['consumidor-pessoa-juridica']['data-fundacao'], true)
                        : 'Não informado'
                    }}
                </el-descriptions-item>

                <el-descriptions-item
                    :span="4" 
                    label="Endereço"
                >
                    {{ getFormattedAddress(getConsumer['consumidor-pessoa-juridica']['endereco']) }}
                </el-descriptions-item>

            
            </el-descriptions>

            <!-- Dados do Consumidor (PF) -->
            <el-descriptions 
                v-if="getConsumer['consumidor-pessoa-fisica']" 
                title="Dados do consumidor (PF)" 
                :column="4" 
                size="small" 
                :border="true"
            >
                <el-descriptions-item 
                    :span="4" 
                    label="Nome"
                >
                    <span v-if="getConsumer['consumidor-pessoa-fisica']['nome']">
                        {{ getConsumer['consumidor-pessoa-fisica']['nome'] || 'Não informado' }}
                    </span>
                </el-descriptions-item>

                <el-descriptions-item 
                    :span="4" 
                    label="CPF"
                >
                    <span v-if="getConsumer['consumidor-pessoa-fisica']['cpf']['numero']">
                        {{ 
                            getConsumer['consumidor-pessoa-fisica']['cpf']['numero'] 
                                ? formatCPF(getConsumer['consumidor-pessoa-fisica']['cpf']['numero']) 
                                : 'Não informado'
                        }}
                    </span>
                </el-descriptions-item>

                <el-descriptions-item 
                    :span="4" 
                    label="Situação CPF"
                >
                    {{ getConsumer['consumidor-pessoa-fisica']['situacao-cpf']
                        ? getConsumer['consumidor-pessoa-fisica']['situacao-cpf']['descricao-situacao']
                        : 'Não informado' 
                    }}
                </el-descriptions-item>

                <el-descriptions-item 
                    :span="4" 
                    label="Data de Nascimento"
                >
                    {{
                        getConsumer['consumidor-pessoa-fisica']['data-nascimento']
                        ? formatDate(getConsumer['consumidor-pessoa-fisica']['data-nascimento'], true)
                        : 'Não informado'
                    }}
                </el-descriptions-item>

                <el-descriptions-item
                    :span="4" 
                    label="Endereço"
                >
                    {{ getFormattedAddress(getConsumer['consumidor-pessoa-fisica']['endereco']) }}
                </el-descriptions-item>
            </el-descriptions>

            <!-- Resumo da Consulta -->
            <el-descriptions class="my-3" title="Resumo da Consulta" :column="4" size="small" :border="true">
                <el-descriptions-item 
                    :span="4" 
                    label="Restrição"
                >
                    <el-tag 
                        :type="!spcConsulta.restricao ? 'danger' : 'success'"
                        class="rounded-pill"
                        size="small"
                    >
                        <span v-if="!spcConsulta.restricao">Sim</span>
                        <span v-else>Não</span>
                    </el-tag>
                </el-descriptions-item>

                <el-descriptions-item 
                    :span="4" 
                    label="Consultas (90 dias)"
                >
                    <span v-if="getConsult">{{ getConsult.resumo['quantidade-total'] }}</span>
                    <span v-else>0</span>
                </el-descriptions-item>
            </el-descriptions>

            <el-collapse v-model="activeResume">
                <el-collapse-item name="1">
                    <template slot="title">
                        <div class="flex-grow-1 d-flex align-items-center justify-content-between pr-3">
                            <span>SPC</span>
                            <el-tag type="danger">
                                {{ getSPCResumTotal }}
                            </el-tag>
                        </div>
                    </template>
                    <div v-if="getSPCResumTotal > 0">
                        <CardBase v-if="getSPCDetails">
                            <el-table
                                class="rounded"
                                v-loading="isLoading"
                                :data="getSPCDetails"
                                align="center"
                                border
                            >
                                <!-- Nome -->
                                <el-table-column label="Nome" min-width="90" align="left">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row['nome-associado']">{{ scope.row['nome-associado'] }}</span>
                                        <span v-else>Nome da empresa indisponível</span>
                                    </template>
                                </el-table-column>

                                <!-- Uf -->
                                <el-table-column 
                                    label="UF" 
                                    width="60" 
                                    align="left"
                                >
                                    <template slot-scope="scope">
                                        <span>{{ scope.row['cidade-associado']['estado']['sigla-uf'] }}</span>
                                    </template>
                                </el-table-column>

                                <!-- Cidade -->
                                <el-table-column 
                                    label="Cidade" 
                                    width="160" 
                                    align="left"
                                >
                                    <template slot-scope="scope">
                                        <span>{{ scope.row['cidade-associado']['nome'] }}</span>
                                    </template>
                                </el-table-column>

                                <!-- Valor -->
                                <el-table-column label="Valor" width="160" align="left">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row['valor']">{{ formatCurrency(scope.row['valor']) }}</span>
                                        <span v-else>Valor indisponível</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </CardBase>
                    </div>

                    <el-empty v-else description="Nenhum detalhe sobre SPC disponível."></el-empty>
                </el-collapse-item>

                <el-collapse-item name="2">
                    <template slot="title">
                        <div class="flex-grow-1 d-flex align-items-center justify-content-between pr-3">
                            <span>Protestos</span>
                            <el-tag type="danger">
                                {{ getProtestResumTotal }}
                            </el-tag>
                        </div>
                    </template>

                    <div v-if="getProtestResumTotal > 0">
                        <CardBase v-if="getProtestDetails">
                            <el-table
                                class="rounded"
                                v-loading="isLoading"
                                :data="getProtestDetails"
                                align="center"
                                border
                            >
                                <!-- Catorio -->
                                <el-table-column label="Catorio" min-width="90" align="left">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row['cartorio']['nome']">{{ scope.row['cartorio']['nome'] }}</span>
                                        <span v-else>Cartorio não informado</span>
                                    </template>
                                </el-table-column>

                                <!-- Uf -->
                                <el-table-column 
                                    label="UF" 
                                    width="60" 
                                    align="left"
                                >
                                    <template slot-scope="scope">
                                        <span>{{ scope.row['cartorio']['cidade']['estado']['sigla-uf'] }}</span>
                                    </template>
                                </el-table-column>

                                <!-- Cidade -->
                                <el-table-column 
                                    label="Cidade" 
                                    width="160" 
                                    align="left"
                                >
                                    <template slot-scope="scope">
                                        <span>{{ scope.row['cartorio']['cidade']['nome'] }}</span>
                                    </template>
                                </el-table-column>

                                <!-- Valor -->
                                <el-table-column label="Valor" width="160" align="left">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row['valor']">{{ formatCurrency(scope.row['valor']) }}</span>
                                        <span v-else>Valor indisponível</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </CardBase>
                    </div>
                
                    <el-empty v-else description="Nenhum detalhe sobre protesto disponível."></el-empty>
                </el-collapse-item>
            </el-collapse>
        </CardBase>
        </el-drawer>
    </div>
</template>
<script>
    // Components
    import {
        Loading,
        Row,
        Col,
        Button,
        Input,
        Notification,
        Form,
        FormItem,
        Tag,
        Avatar,
        InputNumber,
        Drawer,
        Descriptions,
        DescriptionsItem,
        Collapse,
        CollapseItem,
        Empty,
        Table, 
        TableColumn,
    } from "element-ui";

    import CardBase from '@/components/_macro/CardBase.vue';
    
    // Utils
    import { formatDate, formatCNPJ, formatCPF, formatCurrency } from "@/util/formatters";

    // Api
    import { SPCApi } from "@/api/SPCApi";
    const spcConsultasApi = new SPCApi();

    export default {
        name: 'spc-show',
        data() {
            return {
                activeResume: '0',
                spcConsultaId: null,
                payload: {
                    codigo_protheus: null,
                    descricao: null,
                },
                showModal: false,
                isLoading: false,
                spcConsulta: null,
            }
        }, 
        methods: {
            async show() {
                try {
                    this.isLoading = true;

                    const res = await spcConsultasApi.show(this.spcConsultaId);

                    this.spcConsulta = res;
                } catch (error) { 
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter a consulta SPC. Algo inesperado ocorreu!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            getFormattedAddress(address) {
                if (!address) return "Não informado";

                const estado = (address.cidade && address.cidade.estado && address.cidade.estado["sigla-uf"]) || "";

                return `${address.logradouro || ""}, ${address.numero || "S/N"} - ${
                    address.bairro || ""
                }, ${address.cidade.nome || ""} - ${estado}, CEP: ${
                    address.cep || ""
                }`;
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            /**Utils */
            formatDate,
            formatCNPJ,
            formatCPF,
            formatCurrency
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['user/isAnyRole']([
                    'adm',
                    'coord_comercial',
                    'gerente_regional'
                ]);
            },
            getProtocol() {
                return this.spcConsulta?.protocolo
            },
            getOperator() {
                return this.spcConsulta?.operador
            },
            getConsumer() {
                return this.spcConsulta?.consumidor
            },
            getConsult() {
                return this.spcConsulta?.["consulta-realizada"]
            },
            getSPCResumTotal() {
                return this.spcConsulta?.["spc"]["resumo"]["quantidade-total"] || 0;
            },
            getSPCDetails() {
                let details = this.spcConsulta?.["spc"]["detalhe-spc"];

                if(details.length > 0) {
                    return details;
                }

                return [
                    {
                        "nome-associado": details["nome-associado"] ?? 'Nome da empresa indisponível',
                        "valor": details["valor"],
                    }
                ]
            },
            getProtestResumTotal() {
                return this.spcConsulta?.["protesto"]["resumo"]["quantidade-total"] || 0;
            },
            getProtestDetails() {
               return this.spcConsulta?.["protesto"]["detalhe-protesto"];
            }
        },
        components: {
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [Button.name]: Button,
            [Tag.name]: Tag,
            [Avatar.name]: Avatar,
            [InputNumber.name]: InputNumber,
            [Drawer.name]: Drawer,
            [Descriptions.name]: Descriptions,
            [DescriptionsItem.name]: DescriptionsItem,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [Empty.name]: Empty,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            CardBase,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_macro/spc/SPCShowModal.vue